import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MyProfileChangeDto, MyProfileDto } from '../entities/my-profile-dto';
import { MyUserGroupDto } from '../entities/user-group-entities/organization-user-group-dto';
import { ParentApiService } from './parent-api-service';

@Injectable({ providedIn: 'root' })
export class MyProfileApiService extends ParentApiService {
  private readonly url = `${environment.webApiAddress}/api/my-profile`;

  constructor(private readonly http: HttpClient) {
    super();
  }

  getMyProfile(stayOnPageIfError?: boolean): Observable<MyProfileDto> {
    return this.http.get<MyProfileDto>(this.url, { headers: this.headersFor(stayOnPageIfError) });
  }

  updateMyProfile(dto: MyProfileChangeDto, stayOnPageIfError?: boolean): Observable<void> {
    return this.http.put<void>(this.url, dto, { headers: this.headersFor(stayOnPageIfError) });
  }

  getMyUserGroups(stayOnPageIfError?: boolean): Observable<MyUserGroupDto[]> {
    return this.http.get<MyUserGroupDto[]>(`${this.url}/user-groups`, { headers: this.headersFor(stayOnPageIfError) });
  }
}
